import React from "react";
import { AlertTriangle } from "lucide-react";

function Notice({ testid, title, children }) {
  return (
    <div data-testid={testid} className="border border-amber-500/30 bg-amber-500/5 text-amber-300 rounded-sm p-4 text-sm">
      <div className="flex items-start gap-3">
        <AlertTriangle size={16} className="mt-0.5 shrink-0" />
        <div>
          {title && <div className="font-semibold mb-1">{title}</div>}
          <div className="text-xs leading-relaxed opacity-90">{children}</div>
        </div>
      </div>
    </div>
  );
}

/** Pre-requisite guards — returns the notice to render, or null when Infobip can be used. */
export function InfobipGuard({ site, status }) {
  if (!site.domain) {
    return <Notice testid="infobip-no-domain" title="No domain yet">Purchase or attach a domain on the Domain tab before connecting Infobip.</Notice>;
  }
  if (!site.cloudflare_zone_id) {
    return (
      <div data-testid="infobip-no-cf-zone" className="border border-amber-500/30 bg-amber-500/5 text-amber-300 rounded-sm p-4 text-sm">
        Infobip integration writes its DNS records into Cloudflare — set up the Cloudflare zone first.
      </div>
    );
  }
  if (status && status.configured === false) {
    return (
      <Notice testid="infobip-not-configured" title="Infobip not configured">
        Add <span className="mono">INFOBIP_BASE_URL</span> + <span className="mono">INFOBIP_API_KEY</span> to the backend environment, then reconnect.
      </Notice>
    );
  }
  return null;
}
